/* copied and adjusted from Desp footer code footer.js, feather-icons imported instead of feather.js */
import { Component, AfterViewInit, ElementRef, Renderer2 } from '@angular/core';
import feather from 'feather-icons';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements AfterViewInit {
  footer!: HTMLElement;
  footerHeight!: string;
  footerMenuIcon!: HTMLElement;
  footerMenu!: HTMLElement;
  footerMenuIsVisible = false;
  footerHidingTimeoutId: any;
  footerMenuHidingTimeoutId: any;
  footerHideTimeout = 4000;
  footerMenuHideTimeout = 4000;
  footerHasRevealed = true;
  footerScrollPositionPrec = 0;
  tempFooterPrevPos = 0;

  constructor(private elRef: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    setTimeout(() => {
      this.footer = this.elRef.nativeElement.querySelector('#footer-container');
      this.footerMenuIcon =
        this.elRef.nativeElement.querySelector('#footer-menu-icon');
      this.footerMenu = this.elRef.nativeElement.querySelector('#footer-menu');
      this.footerHeight = getComputedStyle(document.body).getPropertyValue(
        '--footer-height'
      );
      this.initializeFeatherIcons();

      // use .router-content for scroll events instead of window
      const routerContent = document.querySelector(
        '.router-content'
      ) as HTMLElement;
      if (routerContent) {
        routerContent.addEventListener('scroll', this.handleScroll.bind(this));
      }
      this.setupMouseListeners();
      // call setupFooterMenuIcon to initialize menu icon events
      this.setupFooterMenuIcon();
    }, 0);
  }

  initializeFeatherIcons() {
    feather.replace();
  }

  handleScroll(event: Event) {
    const target = event.target as HTMLElement;
    const deltaY = target.scrollTop - this.tempFooterPrevPos;

    if (target.scrollTop >= target.scrollHeight - target.clientHeight - 50) {
      this.showFooter();
    } else {
      if (deltaY < 0 && deltaY > -100) {
        setTimeout(() => {
          this.footerScrollPositionPrec = target.scrollTop;
        }, 500);
        if (this.footerHasRevealed) {
          clearTimeout(this.footerHidingTimeoutId);
          this.hideFooter();
          setTimeout(() => {
            this.footerMenuIcon.setAttribute('data-feather', 'menu');
            this.hideFooterMenu();
            this.setFeather();
          }, 500);
        }
      } else if (deltaY > 0 && deltaY < 100) {
        if (target.scrollTop - this.footerScrollPositionPrec > 0) {
          this.showFooter();
          this.footerHidingTimeoutId = setTimeout(() => {
            this.hideFooter();
          }, this.footerHideTimeout);
        }
      }
    }

    this.tempFooterPrevPos = target.scrollTop;
  }

setupMouseListeners() {
  this.footer.addEventListener('mouseover', () => {
    clearTimeout(this.footerHidingTimeoutId);
  });

  this.footer.addEventListener('mouseleave', () => {
    clearTimeout(this.footerHidingTimeoutId);
    this.footerHidingTimeoutId = setTimeout(() => {
      this.hideFooter();
    }, this.footerHideTimeout);
  });

  const hoverZone = document.querySelector('.footer-hover-zone') as HTMLElement | null;
  if (hoverZone) {
    hoverZone.addEventListener('mouseenter', () => {
      this.showFooter();
      clearTimeout(this.footerHidingTimeoutId);
    });
  }

  document.onmousemove = (e: MouseEvent) => {
    if (e.clientY > window.innerHeight - 50) {
      this.showFooter();
    }
  };
}

  hideFooter() {
    if (this.footerHasRevealed) {
      this.footerHasRevealed = false;
      this.renderer.setStyle(
        this.footer,
        'transition',
        'bottom 500ms ease-in-out, background-color 500ms ease-in-out'
      );
      this.renderer.setStyle(this.footer, 'bottom', `-${this.footerHeight}`);
    }
  }

  showFooter() {
    this.renderer.setStyle(
      this.footer,
      'transition',
      'bottom 250ms ease-in-out, background-color 500ms ease-in-out'
    );
    this.renderer.setStyle(this.footer, 'bottom', '0px');
    this.renderer.setStyle(this.footer, 'position', 'fixed');
    setTimeout(() => {
      this.footerHasRevealed = true;
    }, 500);
    clearTimeout(this.footerHidingTimeoutId);
  }

  hideFooterMenu() {
    this.footerMenu.style.display = 'none';
    this.footerMenuIsVisible = false;
  }

  setupFooterMenuIcon() {
    this.footerMenuIcon.addEventListener('click', (e) => {
      clearTimeout(this.footerMenuHidingTimeoutId);
      if (this.footerMenuIsVisible) {
        this.footerMenuIcon.setAttribute('data-feather', 'menu');
        this.hideFooterMenu();
      } else {
        this.footerMenuIcon.setAttribute('data-feather', 'x');
        this.footerMenu.style.display = 'flex';
        this.footerMenuIsVisible = true;
        this.footerMenuHidingTimeoutId = setTimeout(() => {
          this.footerMenuIcon.setAttribute('data-feather', 'menu');
          this.hideFooterMenu();
          this.setFeather();
        }, this.footerMenuHideTimeout);
      }
      this.setFeather();
    });

    this.footerMenu.addEventListener('mouseover', () => {
      clearTimeout(this.footerMenuHidingTimeoutId);
      clearTimeout(this.footerHidingTimeoutId);
    });

    this.footerMenu.addEventListener('mouseleave', () => {
      clearTimeout(this.footerMenuHidingTimeoutId);
      this.footerMenuHidingTimeoutId = setTimeout(() => {
        this.footerMenuIcon.setAttribute('data-feather', 'menu');
        this.hideFooterMenu();
        this.setFeather();
      }, this.footerMenuHideTimeout);
      clearTimeout(this.footerHidingTimeoutId);
      this.footerHidingTimeoutId = setTimeout(() => {
        this.hideFooter();
      }, this.footerHideTimeout);
    });
  }

  setFeather() {
    feather.replace();
    this.footerMenuIcon =
    this.elRef.nativeElement.querySelector('#footer-menu-icon');
    this.setupFooterMenuIcon();
  }
}
